// Mock data for Laundryma - Motherly Wash
// NOTE: All data below is MOCKED for the frontend teaser. Replace with backend later.

export const BRAND = {
  name: "Laundryma",
  tagline: "Motherly Wash",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_laundryma-express/artifacts/z8pnn4y6_LMA%20-%20Logo%20-%20Final1.webp",
  favicon: "https://customer-assets-39nsmqrw.emergentagent.net/job_laundryma-express/artifacts/atp8xd7q_LMA%20-%20Favicon.png",
  phone: "9993300949",
  phoneDisplay: "+91 99933 00949",
  whatsapp: "919993300949",
  email: "care@laundryma.com",
  coupon: "MY25",
  discount: "25%",
};

export const IMAGES = {
  heroFolded: "https://images.unsplash.com/photo-1635274605638-d44babc08a4f",
  cleanBasket: "https://images.unsplash.com/photo-1582735689369-4fe89db7114c",
  facility: "https://images.unsplash.com/photo-1765176938654-ac6f04c1d86b",
  machineCloseup: "https://images.unsplash.com/photo-1761403460807-a89b7de9b4d3",
  deliveryVan: "https://images.unsplash.com/photo-1620455800201-7f00aeef12ed",
  handDelivery: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55",
  dryClean1: "https://images.unsplash.com/photo-1549037173-e3b717902c57",
  dryClean2: "https://images.unsplash.com/photo-1451933335233-c41672c8f378",
  dryClean3: "https://images.unsplash.com/photo-1520434901111-8e9bcb42c628",
  ironing: "https://images.unsplash.com/photo-1489274495757-95c7c837b101",
  foldedStack: "https://images.unsplash.com/photo-1604176354204-9268737828e4",
};

export const NAV_LINKS = [
  { label: "Dry Cleaning", href: "/services/dry-cleaning" },
  { label: "Laundry", href: "/services/laundry" },
  { label: "Shoe Cleaning", href: "/services/shoe-cleaning" },
  { label: "Prepaid Plans", href: "/plans" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/contact" },
];

export const HERO_STATS = [
  { value: "92", label: "Cities" },
  { value: "195", label: "Outlets" },
  { value: "700K+", label: "Downloads" },
  { value: "4.5+", label: "Rating" },
];

export const HERO_CITIES = [
  "Ahmedabad", "Bengaluru", "Bhopal", "Chennai", "Delhi", "Gurgaon",
  "Hyderabad", "Indore", "Jaipur", "Lucknow", "Mumbai", "Nagpur",
  "Noida", "Patna", "Pune", "Thane", "Vadodara", "Varanasi",
];

export const HERO_PILLS = [
  { label: "Dry Cleaning", color: "#237BF6", top: "20%", left: "10%" },
  { label: "Wash Only", color: "#237BF6", top: "58%", left: "72%" },
  { label: "Shoe Cleaning", color: "#F5941F", top: "72%", left: "8%" },
  { label: "Saree Polishing", color: "#2ecc71", top: "80%", left: "55%" },
  { label: "Woolen Dry Clean", color: "#9b59b6", top: "62%", left: "36%" },
  { label: "Premium Laundry", color: "#237BF6", top: "14%", left: "56%" },
];

// ---- Dry Clean & Item-wise Rate Cards ----
export const DRYCLEAN_RATES = [
  {
    title: "DryClean",
    icon: "Shirt",
    unit: "/pc",
    items: [
      { name: "Shirt", mrp: 119, price: 89 },
      { name: "T Shirt", mrp: 109, price: 82 },
      { name: "Jeans", mrp: 139, price: 104 },
      { name: "Dress", mrp: 299, price: 224 },
      { name: "Trouser / Pant", mrp: 139, price: 104 },
      { name: "Ladies Top", mrp: 159, price: 119 },
      { name: "Kids Dress", mrp: 179, price: 134 },
      { name: "Saree - R", mrp: 179, price: 134 },
      { name: "Kurta / Kameez", mrp: 159, price: 119 },
      { name: "Coat", mrp: 309, price: 232 },
      { name: "Sweater Full", mrp: 240, price: 180 },
      { name: "Blanket - D", mrp: 499, price: 374 },
    ],
    link: "/services/dry-cleaning",
  },
  {
    title: "Organic Dryclean",
    icon: "Leaf",
    unit: "/pc",
    items: [
      { name: "Shirt", mrp: 179, price: 134 },
      { name: "T Shirt", mrp: 159, price: 119 },
      { name: "Jeans", mrp: 209, price: 157 },
      { name: "Dress", mrp: 450, price: 338 },
      { name: "Trouser / Pant", mrp: 209, price: 157 },
      { name: "Ladies Top", mrp: 240, price: 180 },
      { name: "Kids Dress", mrp: 269, price: 202 },
      { name: "Saree - R", mrp: 269, price: 202 },
      { name: "Kurta / Kameez", mrp: 240, price: 180 },
      { name: "Coat", mrp: 459, price: 344 },
      { name: "Sweater Full", mrp: 359, price: 269 },
      { name: "Quilt / Rajai - D", mrp: 499, price: 374 },
    ],
    link: "/services/organic-dry-cleaning",
  },
  {
    title: "Shoe Cleaning",
    icon: "Footprints",
    unit: "/pc",
    items: [
      { name: "Sneakers", mrp: 519, price: 389 },
      { name: "Sports", mrp: 470, price: 353 },
      { name: "Belle", mrp: 329, price: 247 },
      { name: "Leather", mrp: 549, price: 412 },
      { name: "Kids Shoe", mrp: 379, price: 284 },
      { name: "Slippers", mrp: 129, price: 97 },
      { name: "Suede", mrp: 769, price: 577 },
      { name: "Boots", mrp: 859, price: 644 },
      { name: "High Top Sneakers", mrp: 589, price: 442 },
      { name: "Jordan Shoes", mrp: 649, price: 487 },
    ],
    link: "/services/shoe-cleaning",
  },
  {
    title: "Bag Cleaning",
    icon: "Briefcase",
    unit: "/pc",
    items: [
      { name: "Backpack", mrp: 549, price: 412 },
      { name: "Laptop Bag", mrp: 329, price: 247 },
      { name: "Ladies Hand Purse", mrp: 729, price: 547 },
      { name: "Ladies Purse", mrp: 879, price: 659 },
      { name: "Trolley - S", mrp: 660, price: 495 },
      { name: "Trolley - M", mrp: 819, price: 614 },
      { name: "Trolley - L", mrp: 989, price: 742 },
      { name: "Mens Wallet", mrp: 249, price: 187 },
      { name: "Kids School Bag", mrp: 309, price: 232 },
    ],
    link: "/services/bag-cleaning",
  },
  {
    title: "Leather Jacket",
    icon: "Wind",
    unit: "/pc",
    items: [
      { name: "Leather Jacket - H", mrp: 529, price: 397 },
      { name: "Leather Jacket - F", mrp: 660, price: 495 },
      { name: "Leather Jacket Premium", mrp: 1759, price: 1319 },
      { name: "Leather Jacket Rexine", mrp: 470, price: 353 },
      { name: "Leather Jacket Suede", mrp: 809, price: 607 },
    ],
    link: "/services/jacket-cleaning",
  },
  {
    title: "Sofa Cleaning",
    icon: "Sofa",
    unit: "/seat",
    items: [
      { name: "Sofa / Seat", mrp: null, price: 399 },
      { name: "Leather Sofa / Seat", mrp: null, price: 479 },
      { name: "Dining Chair", mrp: null, price: 249 },
      { name: "Small Chair", mrp: null, price: 189 },
      { name: "Cushion Large", mrp: null, price: 129 },
      { name: "Cushion Small", mrp: null, price: 119 },
    ],
    link: "/services/sofa-cleaning",
  },
];

// ---- Wash / Laundry Per-Kg Services ----
export const WASH_SERVICES = [
  {
    title: "Wash Only Service",
    price: 64, mrp: 85, unit: "/kg",
    desc: "After our meticulous wash, your clothes emerge not just clean but refreshed, ensuring a crisp, fresh finish every time.",
    features: ["Washing", "Bundle Packing", "Normal Service"],
  },
  {
    title: "Organic Wash Service",
    price: 86, mrp: 114, unit: "/kg",
    desc: "Opt for our organic wash - a gentle touch that not only cleans your clothes but also keeps them safe from harsh chemicals.",
    features: ["Organic Washing", "Bundle Packing", "Normal Service"],
  },
  {
    title: "Wash + Iron Service",
    price: 108, mrp: 144, unit: "/kg",
    desc: "State-of-the-art front loading washing machines and premium detergents for wash, followed by steam ironing.",
    features: ["Wash & Iron", "Bundle Packing", "Normal Service"],
  },
  {
    title: "Organic Laundry",
    price: 129, mrp: 172, unit: "/kg",
    desc: "Experience eco-friendly organic care using green chemicals and a premium wash & iron service for all your garments.",
    features: ["Eco-Friendly Chemicals", "Wash & Iron", "Polybag Free"],
  },
  {
    title: "Premium Laundry",
    price: 137, mrp: 183, unit: "/kg",
    desc: "Premium laundry includes collar & cuff cleaning, stain spotting, wash & iron, and multi-layer packing for best results.",
    features: ["Wash & Iron", "Collar & Cuff", "Spotting", "Multi Packing"],
  },
  {
    title: "Woolen Wash",
    price: 161, mrp: 215, unit: "/kg",
    desc: "Expert woolen care wash that preserves the texture and softness of your woolens while removing all dirt and odours.",
    features: ["Woolen Care Wash", "Normal Service"],
  },
];

// ---- Prepaid Plans ----
export const PREPAID_PLANS = [
  {
    title: "Small Plan", price: "1,399", note: "Perfect for occasional users",
    features: ["Premium Laundry @ ₹180/kg", "Laundry @ ₹142/kg", "Dry Clean 10% off", "Organic Dry Clean 5% off", "Free Pickup & Delivery"],
    recommended: false,
  },
  {
    title: "Medium Plan", price: "2,199", note: "Great value for regular users",
    features: ["Premium Laundry @ ₹177/kg", "Laundry @ ₹140/kg", "Dry Clean 15% off", "Organic Dry Clean 10% off", "Free Pickup & Delivery"],
    recommended: false,
  },
  {
    title: "Big Plan", price: "5,555", note: "Best value for frequent users",
    features: ["Premium Laundry @ ₹172/kg", "Laundry @ ₹133/kg", "Dry Clean 20% off", "Organic Dry Clean 15% off", "Free Pickup & Delivery"],
    recommended: true,
  },
  {
    title: "Jumbo Plan", price: "11,999", note: "Maximum savings for power users",
    features: ["Premium Laundry @ ₹167/kg", "Laundry @ ₹128/kg", "Dry Clean 23% off", "Organic Dry Clean 20% off", "Free Pickup & Delivery"],
    recommended: false,
  },
];

// ---- 10-Step Process ----
export const PROCESS_STEPS = [
  { no: "01", title: "Dirty Clothes", icon: "Shirt" },
  { no: "02", title: "Easy Pickup", icon: "Truck" },
  { no: "03", title: "Inspection by Experts", icon: "Search" },
  { no: "04", title: "Dry Spotting", icon: "Droplets" },
  { no: "05", title: "Preprocessing", icon: "Layers" },
  { no: "06", title: "Processing", icon: "WashingMachine" },
  { no: "07", title: "Steam Ironing", icon: "Flame" },
  { no: "08", title: "QC & Packing", icon: "PackageCheck" },
  { no: "09", title: "Delivery", icon: "Bike" },
  { no: "10", title: "Happy Customer", icon: "Smile" },
];

// ---- Why We Are Best ----
export const WHY_US = [
  { title: "Paper Less", desc: "Embrace paperless processes for enhanced tracking and a greener, more environmentally friendly approach.", icon: "FileText" },
  { title: "Real Time Tracking", desc: "Access real-time updates effortlessly through our customer-friendly app for seamless information.", icon: "Radar" },
  { title: "Free Pickup & Delivery", desc: "Free pick-up and delivery at your doorstep for hassle-free dry cleaning and laundry services.", icon: "Truck" },
  { title: "Enzyme Based Agents", desc: "Experience the power of enzyme-based cleaning agents for effective and eco-friendly solutions.", icon: "FlaskConical" },
  { title: "7 Day Guarantee", desc: "Enjoy peace of mind with our 7-day satisfaction guarantee, or we'll reprocess at no extra cost.", icon: "ShieldCheck" },
  { title: "Eco-Friendly Process", desc: "From biodegradable packaging to water-efficient machines, every step reduces environmental impact.", icon: "Leaf" },
];

// ---- Numbers ----
export const NUMBERS = [
  { value: "5.2 Cr+", label: "Clothes Washed" },
  { value: "38 L+", label: "Orders Processed" },
  { value: "4.12 L+", label: "Satisfied Families" },
  { value: "195", label: "Outlets" },
  { value: "92", label: "Cities" },
  { value: "4.5+", label: "Rating" },
];

// ---- Testimonials ----
export const TESTIMONIALS = [
  { name: "Shraddha Dey", role: "Associate, Samsung Electronics", text: "Laundryma rocks..... very good in service and commitment, faster than expected. I think they are the best dry cleaner near me." },
  { name: "Shubhankar Sharma", role: "IT Professional", text: "I have been a regular customer since more than a year. The responsiveness has been great. Their set up has the rare combination of systemic rigour along with individual care. Would surely recommend." },
  { name: "Deepshikha", role: "Student", text: "Best online laundry services in the city. I primarily use the laundry services, good value for money and customer service. Very polite staff!" },
  { name: "Manish Oberoi", role: "Businessman", text: "Hassle-free laundry at reasonable rates. They pick up from your doorstep and deliver back. You get notifications at every step. Totally satisfied. I recommend Laundryma to everyone." },
];

// ---- Media ----
export const MEDIA = ["Forbes", "Gulf News", "Indian Express", "BW Disrupt", "Hindustan Times", "ET Tech", "Entrepreneur", "Your Story", "Mid-Day", "CNBC TV18"];

// ---- Solutions ----
export const SOLUTIONS = [
  { title: "Eco Friendly & Ethical Products", desc: "We utilize only eco-friendly chemicals from laundry to dry-clean your valuable garments — delicate to clothing and safe for the environment.", icon: "Leaf" },
  { title: "Reasonable Pricing", desc: "We offer incredibly pocket-friendly services with very controlled rates for dry-cleaning and laundry. Check our packages to save more.", icon: "IndianRupee" },
  { title: "Professional Care", desc: "A wide scope of established dry cleaning and laundry services with specialists to manage your clothing in the most ideal manner.", icon: "Sparkles" },
  { title: "On Demand Online Service", desc: "We are an online on-demand laundry & dry-cleaning service in your city. Pick whatever time is useful for you.", icon: "Clock" },
  { title: "In-House Processing Center", desc: "We measure services using an in-house method that fits all requirements with on-time delivery using industrial machines.", icon: "Factory" },
  { title: "Trained & Certified Staff", desc: "Our team are experts in fabrics with active experience to manage any cleaning service needed. Well trained and certified.", icon: "GraduationCap" },
];

// ---- FAQs ----
export const FAQS = [
  { q: "What type of cleaning services does Laundryma offer?", a: "Laundryma offers a variety of specialized cleaning services such as laundry cleaning, dry cleaning, organic dry cleaning, shoe cleaning, bag cleaning and sofa/carpet cleaning. In short, Laundryma is a one stop solution for all your cleaning needs." },
  { q: "Do you offer any discounts for first-time customers?", a: "Yes, Laundryma offers discounts to first-time customers. You can use the code MY25 to avail 25% off on your first service." },
  { q: "Is it possible to schedule a pickup and delivery online?", a: "Yes, you can schedule a pickup and delivery of your laundry or dry cleaning items online through our website and WhatsApp. Select your preferred date and time, and track the status of your order with real-time updates." },
  { q: "What do Laundryma's prepaid plans mean?", a: "Laundryma provides prepaid plans with discounted rates. Choose from various custom-tailored plans based on your needs. The plans have no expiration date, allowing you to use them at your convenience." },
  { q: "What is Laundryma's policy for lost or damaged items?", a: "We take utmost care with every item. In the rare event that an item is lost or damaged during our service, we will reimburse up to a maximum of 3 times the processing cost of the garment in your Laundryma Prepaid account." },
  { q: "How long does it take to clean and return garments?", a: "Standard service takes 48 hours. Express services are available for same-day or next-day delivery based on location." },
  { q: "What are Laundryma's payment options?", a: "Laundryma accepts a variety of payment methods, including cash, UPI, credit card, and debit card. You can also pay for your order online." },
  { q: "How does Laundryma ensure hygiene in its process?", a: "We use advanced cleaning agents, high-temperature washes, and sanitized equipment to ensure 100% hygiene in our laundry process." },
];

// ---- App Features ----
export const APP_FEATURES = ["Free pickup & delivery", "Real-time order tracking", "92+ cities across India", "7-day satisfaction guarantee"];

// ---- Cities ----
export const CITIES = [
  "Ahmedabad", "Ambala", "Amravati", "Anantapur", "Asansol", "Azamgarh", "Balrampur", "Bankura", "Bardhaman", "Bengaluru",
  "Bhagalpur", "Bhiwani", "Bhubaneswar", "Bihar Sharif", "Chennai", "Dehradun", "Delhi", "Deoria", "Dimapur", "Durgapur",
  "Faridabad", "Gandhinagar", "Gaya", "Ghaziabad", "Goa", "Gondia", "Gorakhpur", "Greater Noida", "Gurgaon", "Hubballi",
  "Hyderabad", "Jaipur", "Jaisalmer", "Jamui", "Jhunjhunu", "Jodhpur", "Kanpur", "Karnal", "Kurukshetra", "Lucknow",
  "Madurai", "Mira Bhayandar", "Modinagar", "Mohali", "Moradabad", "Motihari", "Mumbai", "Muzaffarpur", "Mysore", "Nagaur",
  "Nagpur", "Nashik", "Navi Mumbai", "Noida", "Palwal", "Panchkula", "Panvel", "Patna", "Pune", "Purnia",
  "Raniganj", "Rourkela", "Siliguri", "Sirsa", "Sohna", "Thane", "Trichy", "Una", "Vadodara", "Vapi",
  "Varanasi", "Wardha", "Washim", "Zirakpur",
];

// ---- Blogs ----
export const BLOGS = [
  { title: "You Thrifted It. Now Please Don't Wear It Before Washing It.", excerpt: "Thrifting is great. Wearing someone else's unwashed clothes without cleaning them first? Less great. Here's exactly what to do.", img: IMAGES.foldedStack },
  { title: "Clothes Shrinking in the Dryer? Here's How to Prevent It", excerpt: "Why clothes shrink in the dryer and how to prevent it. It's frustrating to find your favourite shirt has mysteriously shrunk.", img: IMAGES.ironing },
  { title: "9 Laundry Mistakes Ruining Your Clothes", excerpt: "Garment-care mistakes that fade, stretch, and damage clothes — and simple ways to avoid them every wash day.", img: IMAGES.dryClean2 },
  { title: "Saree Care Guide: Washing & Storing Expensive Sarees Safely", excerpt: "Costly sarees are not just garments. Made of light fabric, zari, sequins or hand-weave — here's how to care for them.", img: IMAGES.cleanBasket },
];

export const LOCALITIES = ["Sector 15", "Sector 22", "Model Town", "Civil Lines", "MG Road", "Vijay Nagar", "Rajwada", "New Palasia", "Old City", "Cantonment"];
